import React from 'react';

export const Table = ({ children, style, tableStyle }) => (
  <div style={{width: '100%', paddingRight: 1}} >
    <table style={{width: '100%', ...style}}>{children}</table>
  </div>
);
